import React from 'react';
import './TemplateList.scss';
import { TemplateItem } from './TemplateItem';

/**
 * TemplateList Component
 * 
 * This component displays a grid of available templates for chapters.
 * It's designed to be reusable across different parts of the application.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {Array} props.templates - Array of template objects to display
 * @param {string} props.direction - Text direction ('ltr' or 'rtl')
 * @param {Function} props.onSelectTemplate - Callback function called when a template is selected
 * @returns {JSX.Element} The rendered TemplateList component
 */
export const TemplateList = ({ templates, direction, onSelectTemplate }) => {
  return (
    <div className="TemplateList">
      {/* Grid of template options */}
      <div className="template-list">
        {/* Map through available templates and render each as a TemplateItem */}
        {templates.map(template => (
          <TemplateItem
            key={template.id}
            template={template}
            direction={direction}
            onSelect={onSelectTemplate}
          />
        ))}
      </div>
    </div>
  );
};
